import Navbar from "../common/Navbar"


export const Checkout =()=>{

    return(
        <>
            <Navbar/>
        </>
    )
}